export default "__VITE_ASSET__B4WX_YmZ__"